import { composeIO } from 'react-compose-io'
import { abaTabelaIO } from './AbaTabela.IO'
import AbaTabelaView from './AbaTabela.View'

export const AbaTabela = composeIO(AbaTabelaView, abaTabelaIO)
